<template>
  <div class="brez-izbirnika">
    <div>
      <p class="navadno-besedilo" style="line-height: 1.5;">
        T-2 ID je edinstvena digitalna identiteta, ki omogoča lažjo
        prijavo v T-2 sisteme, aplikacije in spletne strani. <br/>
        Podatki T-2 ID se lahko razlikujejo od naročniških podatkov.
        Več informacij o upravljanju T-2 identitete je na voljo
        <a :href="urejanjeT2IdentiteteUrl" class="primarna-barva">tukaj</a>.
      </p>
    </div>
    <div class="info-okno" v-if="urejanjePodatkov !== '1'">
      <InfoKomponenta/>
    </div>
    <div class="flex-container" v-loading="pridobivanjeOsebnihPodatkov">
      <span class="mobile-avatar">
        <div class="prikaz-slike-mobi">
          <div v-if="urejanjePodatkov === '1'">
            <div v-if="imgUrl !== null">
              <img :src="imgUrl" alt="Avatar" class="profilna-slika">
              <el-button alt="Avatar" class="profilna-slika spremeni" @click="VnosnoOknoSlike">
                Spremeni
                <span>
                  sliko
                </span>
              </el-button>
            </div>
            <div v-else>
              <el-button alt="Avatar" class="profilna-slika" @click="VnosnoOknoSlike">
                Naloži sliko
              </el-button>
            </div>
            <div>
              <file-reader
                id="profilna-slika-upload"
                accept="image"
                output="binary"
                @reader-load="this.CheckFile">
              </file-reader>
            </div>
          </div>
          <div v-else>
            <img v-if="imgUrl !== null" :src="imgUrl" alt="Avatar" class="profilna-slika">
          </div>
        </div>
      </span>
      <div class="velikost-urejanja-vsebine">
        <div>
          <div>
            <div v-loading="posodobitevPodatkov">
              <el-form label-width="200px" :label-position="formaOrientacija" class="urejanje-profila"
                       :class="urejanjePodatkov === '1' ? 'v-urejanju' : 'ne-urejanje'">
                <span style="float: left" :class="urejanjePodatkov === '1' ? 'ime-urejano' : ''">
                  <img src="/static/img/UrejanjeProfila_icons/Icon-awesome-user-alt.png"
                       class="stil-ikone-uporabnisko-ime">
                </span>
                <el-form-item label="Ime in priimek" :class="urejanjePodatkov === '1' ? 'ime-urejano' : ''">
                  <span v-if="urejanjePodatkov === '1'">
                    <el-input type="text"
                              v-model="ime"
                              maxlength="80"
                              :class="ime === ''? 'input-ime danger' : 'input-ime'"
                              @change="validacija.ImeValidation(ime)">
                    </el-input>
                  </span>
                  <span v-if="urejanjePodatkov === '1'">
                    <el-input type="text"
                              v-model="priimek"
                              maxlength="80"
                              :class="priimek === ''? 'input-priimek danger' : 'input-priimek'"
                              @change="validacija.ImeValidation(priimek)">
                    </el-input>
                  </span>
                  <span v-else class="navadno-besedilo">
                    <b>
                      {{ potrjenoIme ? potrjenoIme : ''}}
                    </b>
                  </span>
                </el-form-item>
                <div style="clear: both"/>
                <span style="float: left">
                  <img src="/static/img/MojT2/T2Klub/Icon-awesome-home.png" class="stil-ikone-naslov">
                </span>
                <el-form-item label="Naslov" :class="urejanjePodatkov === '1' ? 'naslov-urejan' : 'naslov-neurejan'">
                  <span v-if="urejanjePodatkov === '1'">
                    <el-select @change="validacija.PreverjanjeNaslova(naslov)"
                               :remote-method="PreverjanjePredlaganegaNaslova"
                               filterable
                               placeholder="Vnesite naslov"
                               remote
                               allow-create
                               reserve-keyword
                               no-data-text="Ni podatkov"
                               v-model="naslov"
                               :class="naslov === ''? 'input-naslov danger' : 'input-naslov'">
                      <el-option
                        v-for="item in naslovi"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                    <el-input
                      type="text"
                      v-model="hs"
                      maxlength="7"
                      :class="hs === ''? 'input-hisna-stevilka danger' : 'input-hisna-stevilka'"
                    >
                    </el-input>
                  </span>
                  <span v-else class="navadno-besedilo">
                    <b>
                      <span>
                        {{ prviDelNaslovna ? prviDelNaslovna : naslov.split(', ')[0] }} {{potrjenaHs}}
                      </span>
                      <span :class="prviDelNaslovna &&  drugiDelNaslovna ? 'posta-odmik' : ''">
                        {{ drugiDelNaslovna ? drugiDelNaslovna : naslov.split(', ')[1] }}
                      </span>
                    </b>
                  </span>
                </el-form-item>
                <span style="float: left">
                  <img src="/static/img/MojProfil/Icon-awesome-phone-alt-grey.png"
                       class="stil-ikone-telefonska-stevilka">
                </span>
                <el-form-item label="Telefonska številka" :class="urejanjePodatkov === '1' ? 'telefon-urejan' : ''">
                  <span v-if="urejanjePodatkov === '1'">
                    <el-select
                      class="lista-zacetnih-st input-telefonska-stevilka"
                      v-model="telefonT2IDPrviDel"
                      :placeholder="listaZacetnihSt[0]"
                      :disabled="true"
                    >
                      <el-option
                        v-for="st in listaZacetnihSt"
                        :value="st"
                        :label="st"
                        :key="st"
                        :disabled="true"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      placeholder="100100"
                      class="tel-st-vnosno-polje"
                      :maxlength="6"
                      show-word-limit
                      type="text"
                      v-model="telefonT2IDrugiDel"
                      :disabled="true"
                    >
                    </el-input>
                  </span>
                  <span v-else class="navadno-besedilo">
                    <b>
                      {{ potrjenaTelefonskaSt ? VrniFormatiranoTelefonsko(potrjenaTelefonskaSt, '5', true) : ''}}
                    </b>
                  </span>
                </el-form-item>
                <div style="clear: both"/>
                <span style="float: left">
                  <img src="/static/img/MojT2/Dokumenti/Icon-T-2-logo.png" class="stil-ikone-elektronska-posta">
                </span>
                <el-form-item label="Elektronski naslov | T-2 ID" :class="urejanjePodatkov === '1' ?
                              'navadno-besedilo email-urejan' : 'navadno-besedilo'">
                  <span v-if="urejanjePodatkov === '1'">
                    <el-input type="text" v-model="email" :disabled="true" class="input-telefonska-stevilka"
                              suffix-icon="el-icon-lock">
                    </el-input>
                  </span>
                  <span v-else class="navadno-besedilo">
                    <b>
                      {{ email }}
                    </b>
                    <img class="stil-ikone-zaklenjen-email"
                         src="/static/img/Icon/NastavitveTelefonija/Icon-awesome-lock.png">
                  </span>
                  <span v-if="urejanjePodatkov === '1'" class="email-label">
                      <i class="el-icon-warning open-sans-10pt">
                        <small>
                          Ker je T-2 ID povezan z vašim e-naslovom, sprememba e-naslova v uporabniškem vmesniku žal ni mogoča.
                          Za več informacij pokličite 064 064 064 ali obiščite <br>
                            <a :href="urejanjeT2IdentiteteUrl" class="primarna-barva">
                              https://www.t-2.net/upravljanje-s-t-2-id</a>.
                        </small>
                      </i>
                  </span>
                </el-form-item>
                <span style="float: left">
                  <img src="/static/img/MojT2/T2Klub/Icon-metro-female.png" class="stil-ikone-spol">
                </span>
                <el-form-item label="Spol" :class="urejanjePodatkov === '1' ? 'spol-urejan' : ''">
                  <span v-if="urejanjePodatkov === '1'">
                    <el-select v-model="izbranSpol"
                               placeholder="Izberi"
                               :class="izbranSpol === null ? 'input-spol danger' : 'input-spol'">
                      <el-option v-for="spol in izbiraSpola"
                                 :key="spol.value"
                                 :label="spol.label"
                                 :value="spol.value">
                      </el-option>
                    </el-select>
                  </span>
                  <span v-else class="navadno-besedilo">
                    <b>
                      {{ izbranSpol !== null ? this.GetGenderLabel(izbranSpol) : ''}}
                    </b>
                  </span>
                </el-form-item>
                <span style="float: left">
                  <img src="/static/img/MojT2/T2Klub/Icon-awesome-birthday-cake.png" class="stil-ikone-rojstni-datum">
                </span>
                <el-form-item label="Rojstni datum"
                              :class="urejanjePodatkov === '1' ? 'input-datum-rojstva pregled' : 'input-datum-rojstva'">
                  <span v-if="urejanjePodatkov === '1'">
                    <div class="block">
                      <el-date-picker
                        style="transform: translateX(2px);"
                        type="date"
                        placeholder="Izberite datum"
                        :picker-options="pickerOptions"
                        format="dd.MM.yyyy"
                        value-format="yyyy-MM-dd"
                        v-model="datumRojstva">
                      </el-date-picker>
                    </div>
                  </span>
                  <span v-else class="navadno-besedilo datum-rojstva">
                    <b>
                      {{ vrniDatumRojstva }}
                    </b>
                  </span>
                </el-form-item>
              </el-form>
              <div
                v-if="urejanjePodatkov === '0'"
                style="clear: both; display: flex; align-items: center; padding: 15px 0;">
                <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-trash-alt.png" alt="trash"
                     style="width: 17.5px; height: 20px; margin-right: 13px; object-fit: contain; flex-shrink: 0;">
                <a class="stil-gumb-preklici" style="padding: 0;" @click="anonymize">
                  IZBRIŠI T-2 ID RAČUN
                </a>
              </div>
              <div v-if="urejanjePodatkov === '0'" style="padding-top: 40px">
                <div class="d-flex" style="flex-wrap: wrap;">
                  <el-button type="primary"
                             @click="SpremembaPodatkov"
                             class="gumb-potrdi mr-2 mb-1">
                    UREDITE SVOJE PODATKE
                  </el-button>
                  <el-button type="primary"
                             @click="spremeniTelefonskoZacetekPostopka()"
                             class="gumb-potrdi ml-0 mr-2 mb-1">
                    SPREMENITE TELEFONSKO ŠTEVILKO
                  </el-button>
                </div>
              </div>

              <div v-if="urejanjePodatkov === '1'" style="padding-top: 40px" class="urejanje">
                <el-button
                  type="primary"
                  :disabled="nepravilnaTelefonskaStevilka"
                  plain @click="GetUserUpdate"
                  class="gumb-potrdi">
                  SHRANITE SPREMEMBE
                </el-button>
                <a class="stil-gumb-preklici" @click="SpremembaPodatkov">
                  Prekliči
                </a>
                <el-alert v-if="nepravilnaTelefonskaStevilka"
                          title="Nepravilna oblika telefonske številke."
                          :closable="false"
                          type="warning alert" center show-icon
                          class="okno">
                </el-alert>
              </div>
              <div class="info-okno-mobile">
                <InfoKomponenta/>
              </div>

              <div class="zgornji-odmik-pomoc" style="margin-top:30px;margin-right:11px;">
                <div id="bottom">
                  <a :href=urejanjeT2IdentiteteUrl class="primarna-barva" target="_blank">
                    <div class="postavitev-besedila-pomoc">
                      <p class="open-sans-13pt no-bold">
                  <span class="desni-pomik-texta-pomoc">
                    <b>
                      Potrebujete pomoč?
                    </b>
                  </span>
                        <br/>
                        Imamo odgovore na pogosta vprašanja,
                        <br/>
                        lahko nas tudi pokličete na 064 064 064.
                      </p>
                    </div>
                    <div class="desna-postavitev-ikone-pomoc">
                      <i class="fa fa-question-circle"></i>
                    </div>
                  </a>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <sprememba-telefonske-stevilke-popup v-model="spremeniTelefonPopup" @phoneNumberChanged="phoneNumberChanged"/>
    <el-dialog
      :width="'530px'"
      append-to-body
      :visible.sync="anonymizeDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      custom-class="orderButtonConfirmDialog odmikDialoga anonymize-dialog"
    >
      <template v-slot:title>
        <div style="text-align: center; padding-top: 8px;">
          <img
            alt="alert"
            src="/static/img/MojT2/Eposlovanje/Icon-feather-alert-circle.png" style="width: 100px; height: 100px;" />
          <div style="font-weight: bold; font-size: 16px; margin-top: 20px; margin-bottom: 8px;">Opozorilo!</div>
        </div>
      </template>
      <div style="text-align: center" v-loading="anonymizeDialogLoading" :style="anonymizeDialogLoading ? 'min-height: 80px;' : ''">
        <template v-if="!anonymizeDialogLoading">
          <div v-html="anonymizeDialogSporocilo" class="mb-4 dialogText"></div>
          <div class="d-flex" style="flex-direction: column; align-items: center;">
            <el-button
              @click="IzvedeAnonymize"
              type="primary"
              class="gumb-potrdi uppercase"
              style="width:250px;">
              Potrdi
            </el-button>
            <el-button
              @click="anonymizeDialogVisible = false"
              class="gumb-crni-okvir uppercase"
              style="width:250px; margin-left: 0px; border: 0px;">
              PREKLIČI
            </el-button>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import Validacija from 'src/assets/js/globalne_funkcije/Validacija.js'
import {
  Button, Upload, DatePicker, RadioGroup, RadioButton,
  Input, Select, Option, Collapse, CollapseItem, Dialog, Steps, Step
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import FileReader from 'vue-filereader'
import InfoKomponenta from '../UrejanjeProfila/InfoKomponenta'
import {FormatirajTelefonskoStevilko}
  from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'
import $ from 'jquery'
import {ZacetneStevilkeUmtsEnum} from '../../../../../assets/js/Enum/ZacetneStevilkeUmtsEnum'
import InfoKomponentaGlobalna from '../../../../UIComponents/InfoKomponentaGlobalna.vue'
import SpremembaTelefonskeStevilkePopup from './SpremembaTelefonskeStevilkePopup.vue'

export default {
  name: 'OsebniPodatki',
  mixins: [SirinaOkna, FormatirajTelefonskoStevilko],
  data () {
    return {
      clientAgent: null,
      email: '',
      izbranSpol: null,
      izbranSpolPotrjen: null,
      izbiraSpola: [
        {
          value: null,
          label: 'Ni podano'
        },
        {
          value: 0,
          label: 'Ženski'
        },
        {
          value: 1,
          label: 'Moški'
        }],
      imgUrl: null,
      ime: '',
      posodobitevPodatkov: false,
      telefonStevilka: '',
      naslovi: [],
      urejanjePodatkov: '0',
      mejnaSirina: 1400,
      hs: '',
      potrjenoIme: '',
      potrjenaTelefonskaSt: '',
      potrjenNaslov: '',
      potrjenaHs: '',
      datumRojstva: '',
      potrjenDatumRojstva: '',
      urejanjeOsebnihPodatkov: false,
      formaOrientacija: 'left',
      stranUrl: '',
      validacija: null,
      avatarFile: null,
      imgUrlBackup: null,
      drugiDelNaslovna: '',
      prviDelNaslovna: '',
      pridobivanjeOsebnihPodatkov: false,
      pickerOptions: {
        disabledDate (time) {
          let currentDate = new Date()
          return !(time.getTime() > currentDate.getTime() || (time.getFullYear() > currentDate.getFullYear() - 150))
        }
      },
      naslov: '',
      priimek: '',
      listaZacetnihSt: ZacetneStevilkeUmtsEnum,
      telefonT2IDPrviDel: '064',
      telefonT2IDrugiDel: '',
      urejanjeT2IdentiteteUrl: '',
      spremeniTelefonPopup: false,
      anonymizeDialogVisible: false,
      anonymizeDialogLoading: false,
      anonymizeDialogSporocilo: null
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.stranUrl = povezave.BASE_URL_T2_STRAN
    this.urejanjeT2IdentiteteUrl = povezave.BASE_URL_UPRAVLJANJE_S_T2_ID
    this.GetUserData()
    this.validacija = new Validacija()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  computed: {
    vrniDatumRojstva () {
      if (this.potrjenDatumRojstva === null || this.potrjenDatumRojstva.split('-')[0] === '') {
        this.potrjenDatumRojstva = ''
        return this.potrjenDatumRojstva
      } else {
        let datumLocen = this.potrjenDatumRojstva.split('-')
        return datumLocen[2] + '.' + datumLocen[1] + '.' + datumLocen[0]
      }
    },
    nepravilnaTelefonskaStevilka () {
      return this.telefonT2IDrugiDel !== '' && this.telefonT2IDrugiDel.length !== 6
    }
  },
  components: {
    SpremembaTelefonskeStevilkePopup,
    InfoKomponentaGlobalna,
    InfoKomponenta,
    [Button.name]: Button,
    [Upload.name]: Upload,
    [DatePicker.name]: DatePicker,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [FileReader.name]: FileReader,
    [Dialog.name]: Dialog,
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  methods: {
    phoneNumberChanged (prefix, number) {
      this.telefonT2IDPrviDel = prefix
      this.telefonT2IDrugiDel = number
      this.telefonStevilka = prefix + number
      this.potrjenaTelefonskaSt = prefix + number
    },
    spremeniTelefonskoZacetekPostopka () {
      this.spremeniTelefonPopup = true
    },
    GetZacetna (telefonskaStevilka) {
      let zacetnaStevilka = ''
      if (telefonskaStevilka.length === 11) {
        zacetnaStevilka = 0 + telefonskaStevilka.slice(3, 5)
      } else if (telefonskaStevilka.length === 9) {
        zacetnaStevilka = telefonskaStevilka.slice(0, 3)
      }
      if (this.listaZacetnihSt.includes(zacetnaStevilka)) {
        return zacetnaStevilka
      } else {
        return this.listaZacetnihSt[0]
      }
    },
    GetDrugiDelTelefonske (telefonskaStevilka) {
      if (telefonskaStevilka.length === 11) {
        return telefonskaStevilka.slice(5, 12)
      } else if (telefonskaStevilka.length === 9) {
        return telefonskaStevilka.slice(3, 9)
      }
      return ''
    },
    GetGenderLabel (value) {
      for (let i = 0; i < this.izbiraSpola.length; i++) {
        if (this.izbiraSpola[i].value === value) {
          return this.izbiraSpola[i].label
        }
      }
      return ''
    },
    VnosnoOknoSlike () {
      $('.file-reader__control').click()
    },
    UrejanjeOsebnihPodatkov () {
      this.urejanjeOsebnihPodatkov = true
    },
    SpremembaPodatkov () {
      if (this.urejanjePodatkov === '1') {
        if (this.imgUrlBackup !== null) {
          this.imgUrl = this.imgUrlBackup
        }
        this.urejanjePodatkov = '0'
      } else {
        this.urejanjePodatkov = '1'
      }
    },
    PreverjanjePredlaganegaNaslova (preverjanje) {
      if (preverjanje.length > 3 && preverjanje !== '') {
        let ignoredWords = []
        ignoredWords.push('^ulica')
        ignoredWords.push('^ul.')
        ignoredWords.push('^ul')
        for (let i = 0; i < ignoredWords.length; i++) {
          let reg = new RegExp(ignoredWords[i])
          if (reg.test(preverjanje)) {
            let najdenNiz = reg.exec(preverjanje)
            najdenNiz += '' + najdenNiz
            preverjanje = preverjanje.substring(najdenNiz.length - 1)
            break
          }
        }
      }
      if (preverjanje.length > 3 && preverjanje !== '') {
        this.ulice = preverjanje
        let param = ['delniNaziv=' + this.ulice]
        this.clientAgent.postWsRequest(
          this,
          'autocomplete/naslov/Naslov',
          param,
          null,
          'PredlaganStalenNaslovCallback',
          '')
      } else {
        this.naslovi = []
      }
    },
    PredlaganStalenNaslovCallback (podatki) {
      this.naslovi = podatki.data
    },
    GetUserData () {
      this.pridobivanjeOsebnihPodatkov = true
      let param = []
      this.clientAgent.postWsRequest(
        this,
        'user/info',
        param,
        null,
        'SetUserData',
        'ErrUserData')
    },
    SetUserData (podatki) {
      this.imgUrl = null
      this.imgUrlBackup = null
      this.avatarFile = null
      this.email = podatki.email
      this.imgUrl = podatki.picture
      let date = new Date()
      this.imgUrl += '?time=' + date.getTime()
      this.imgUrlBackup = this.imgUrl
      this.naslov = podatki.address
      this.potrjenNaslov = podatki.address
      let n = this.potrjenNaslov.split(', ')
      this.prviDelNaslovna = n[0]
      for (let i = 0; i < n.length; i++) {
        this.drugiDelNaslovna = n[i]
      }
      this.telefonStevilka = podatki.phone
      this.telefonT2IDPrviDel = this.GetZacetna(this.telefonStevilka)
      this.telefonT2IDrugiDel = this.GetDrugiDelTelefonske(this.telefonStevilka)
      this.potrjenaTelefonskaSt = podatki.phone
      this.hs = podatki.hisnaStevilka
      this.potrjenaHs = podatki.hisnaStevilka
      this.datumRojstva = podatki.birthDate
      this.potrjenDatumRojstva = podatki.birthDate
      this.izbranSpol = podatki.gender
      if (this.izbranSpol !== null) {
        if (this.izbranSpol) {
          this.izbranSpol = 1
        } else {
          this.izbranSpol = 0
        }
      }
      this.izbranSpolPotrjen = this.izbranSpol
      if (podatki.name !== '') {
        this.potrjenoIme = podatki.name
        this.ime = this.potrjenoIme.split(' ')[0]
        this.priimek = this.potrjenoIme.split(' ')[1]
        if (typeof this.ime === 'undefined') {
          this.ime = ''
        }
        if (typeof this.priimek === 'undefined') {
          this.priimek = ''
        }
      }
      if (this.imgUrl === null) {
        this.imgUrl = podatki.picture
      }
      this.pridobivanjeOsebnihPodatkov = false
      this.$emit('datumRojstva', this.datumRojstva)
    },
    ErrUserData (podtki) {
      let paramObvestilo = {}
      paramObvestilo.message = podtki.message
      this.ShowWarningMessage(paramObvestilo)
      this.pridobivanjeOsebnihPodatkov = false
    },
    GetCelaTelefonska (stevilkaPrviDel, stevilkaDrugiDel) {
      if (stevilkaDrugiDel !== '' && stevilkaDrugiDel.length === 6) {
        return stevilkaPrviDel.concat(stevilkaDrugiDel)
      }
      return ''
    },
    GetUserUpdate () {
      let posodobitevProfilne = !(typeof this.avatarFile !== 'undefined' && this.avatarFile !== null)
      let spremembaPodatkov =
        (this.potrjenoIme === (this.ime + ' ' + this.priimek) &&
          this.potrjenaHs === this.hs &&
          this.naslov === this.potrjenNaslov &&
          this.datumRojstva === this.potrjenDatumRojstva &&
          this.izbranSpolPotrjen === this.izbranSpol)
      if (spremembaPodatkov && posodobitevProfilne) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Nobenih sprememb podatkov ni bilo vnešenih.'
        this.ShowWarningMessage(paramObvestilo)
        this.posodobitevPodatkov = false
        this.urejanjePodatkov = '0'
      } else {
        if (!posodobitevProfilne) {
          this.ShraniAvatar(this.avatarFile)
          this.$root.$emit('posodobitevSlikeHandler')
        }
        this.potrjenoIme = this.ime + ' ' + this.priimek
        this.potrjenaHs = this.hs
        if (!this.validacija.PreverjanjeNaslova(this.naslov) && this.naslov !== '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Vpisali ste napačen naslov. Prosimo, poskusite ponovno.'
          this.ShowWarningMessage(paramObvestilo)
          this.posodobitevPodatkov = false
          return false
        } else {
          this.posodobitevPodatkov = true
          this.potrjenNaslov = this.naslov
          this.potrjenDatumRojstva = this.datumRojstva
        }
        let prenosniParam = {'spremembaPodatkov': spremembaPodatkov, 'posodobitevProfilne': posodobitevProfilne}
        let param = ['gender=' + this.izbranSpol]
        param.push('name=' + this.potrjenoIme)
        param.push('picture=' + this.imgUrl)
        if (this.potrjenDatumRojstva !== null) {
          param.push('birthDate=' + this.potrjenDatumRojstva)
        }
        param.push('address=' + this.potrjenNaslov)
        param.push('hisnaStevilka=' + this.potrjenaHs)
        this.clientAgent.postWsRequest(
          this,
          'user/update?',
          param,
          prenosniParam,
          'SetUserUpdate',
          'ErrUserUpdate')
      }
    },
    SetUserUpdate (podatki, prenosniParam) {
      if (!prenosniParam.spremembaPodatkov) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Podatke ste uspešno posodobili.'
        this.ShowSuccessMessage(paramObvestilo)
      }
      if (!prenosniParam.posodobitevProfilne) {
        setTimeout(() => {
          let paramObvestilo = {}
          paramObvestilo.message = 'Uspešno spremenjena profilna fotografija.'
          this.ShowSuccessMessage(paramObvestilo)
        }, 500)
      }
      this.GetUserData()
      this.posodobitevPodatkov = false
      this.urejanjePodatkov = '0'
    },
    ErrUserUpdate () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Med shranjevanjen je prišlo do napake. Prosimo, poskusite ponovno.'
      this.ShowWarningMessage(paramObvestilo)
    },
    CheckFile (file) {
      let isValid = this.ValidirajDatoteko(file)
      if (isValid) {
        this.imgUrl = URL.createObjectURL(file.file)
        this.avatarFile = file
      }
    },
    async anonymize () {
      this.anonymizeDialogSporocilo = null
      this.anonymizeDialogLoading = true
      this.anonymizeDialogVisible = true
      try {
        const podatki = await this.clientAgent.makeRequest('permissions/havePermission', { permissionId: 'STRANKE' })
        this.AnonymizeNarocnineCallback(podatki)
      } catch (e) {
        this.AnonymizeNarocnineErrCallback()
      }
    },
    AnonymizeNarocnineCallback (podatki) {
      const gdprLink = `<a href="${povezave.GDPR}" target="_blank" class="primarna-barva">Več o obdelavi podatkov</a>`
      const narocnine = podatki.permission ? podatki.permission.additionalData : null
      const imaNarocnine = narocnine !== null && narocnine.length > 0
      this.anonymizeDialogSporocilo = imaNarocnine
        ? 'Vaš račun je povezan z enim ali več naročniškimi razmerji. ' +
        'Z izbrisom T-2 ID računa boste izgubili dostop do vseh povezanih naročnin in storitev. ' +
        'Morebitni drugi uporabniki, ki imajo dodeljene pravice za upravljanje vašega naročniškega razmerja, ' +
        'te pravice ohranijo. Izbris T-2 ID ne pomeni prenehanja naročniškega razmerja ali naročenih storitev. ' +
        'Osebni podatki bodo izbrisani skladno z veljavno zakonodajo in Informacijo o obdelavi osebnih podatkov.' + gdprLink
        : 'Z izbrisom T-2 ID računa boste izgubili dostop do vseh povezanih storitev. ' +
        'Po izbrisu T-2 ID dostop do tega uporabniškega računa ne bo več mogoč. ' +
        'Osebni podatki se bodo obdelovali skladno z veljavno zakonodajo in ' +
        'Informacijo o obdelavi osebnih podatkov. ' + gdprLink
      this.anonymizeDialogLoading = false
    },
    AnonymizeNarocnineErrCallback () {
      this.anonymizeDialogVisible = false
      this.anonymizeDialogLoading = false
      let paramObvestilo = {}
      paramObvestilo.message = 'Prišlo je do napake pri brisanju T-2 ID računa.'
      this.ShowWarningMessage(paramObvestilo)
    },
    async IzvedeAnonymize () {
      this.anonymizeDialogVisible = false
      try {
        await this.clientAgent.makeRequest('user/anonymize', {})
        this.SetAnonymize()
      } catch (e) {
        this.ErrAnonymize()
      }
    },
    SetAnonymize () {
      this.clientAgent.t2Auth.logout('https://login.t-2.net/account_deleted')
    },
    ErrAnonymize () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Med brisanjem T-2 ID računa je prišlo do napake.'
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/moj_profil/osnovno.css">
</style>
<style>
.anonymize-dialog .el-dialog__body {
  padding-top: 12px;
}
.anonymize-dialog .el-dialog__header {
  padding-bottom: 0;
}
.anonymize-dialog .dialogText a {
  text-decoration: none;
}
.anonymize-dialog .dialogText {
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/UrejanjeProfila/OsebniPodatki.vue